import { useEffect } from 'react';

const useScrollRestoration = () => {
  useEffect(() => {
    // 將滾動恢復設置為手動(默認返回頂部)，用於修復 PWA 滾動至底部時切換頁面後並返回時的白屏問題。
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);
};

export default useScrollRestoration;
